import React from 'react';
import styled from 'styled-components';
import { fonts,colors } from '../common/mixins.js';

const Label = ({ status, cancelledTickets, cancelledProducts, isUnpaidServiceFee }) => {
    const getLabelDetails = (status, cancelledTickets, cancelledProducts, isUnpaidServiceFee) => {
   
        if (status === 'PE' || isUnpaidServiceFee) {
            return { color: `${colors.warning}`, text: `${orderdetails_resources.PendingPayment}` };
        }
        else if (status === 'CN') {
            return { color: `${colors.danger}`, text: `${orderdetails_resources.CancelledPayment}` };
        } else if (cancelledTickets === 1) {
            return { color: `${colors.danger}`, text: `${cancelledTickets} ${orderdetails_resources.CancelledTicket}` };
        } else if (cancelledTickets > 1) {
            return { color: `${colors.danger}`, text: `${cancelledTickets} ${orderdetails_resources.CancelledTickets}` };
        } else if (cancelledProducts === 1) {
            return { color: `${colors.danger}`, text: `${cancelledProducts} ${orderdetails_resources.CancelledProduct}` };
        } else if (cancelledProducts > 1) {
            return { color: `${colors.danger}`, text: `${cancelledProducts} ${orderdetails_resources.CancelledProducts}` };
        } else {
            return { color: `${colors.danger}`, text: `unknown status` };
        }
    };

    const { color, text } = getLabelDetails(status, cancelledTickets, cancelledProducts, isUnpaidServiceFee);

    const StyledLabel = styled.div`
    ${fonts.normalTextExtraSmall()};
    width:fit-content;
    height:26px;
    display:flex;
    align-items:center;
    justify-content:center;
    padding:4px 8px;
    background-color:${color};
    color:white; 
    border-radius:4px;
    `;

    return (
        <StyledLabel>
            {text}
        </StyledLabel >
    );
};

export default Label;
